// Vee bumper gate (docs/BUMPERS.md). The only bumper code in the app bundle: after load and idle,
// with the start page showing, it imports the lazy chunk. Nothing is fetched while bumpers are off
// or branding is meant to stay hidden (shared/brand-quiet.js), and turning on a cloak or Quick hide
// takes the bumper away at once.
import { bumperOn } from "../shared/brand-quiet.js";

// ok: this is not a /?play= or shared link, and the first-run welcome is behind the visitor
// (onboarding-gate.js welcomeBehind(), read at boot). A first visit gets no bumper and no room
// for one; Vee shows from the next visit. The pre-paint holds the room on the same rule, and if
// the chunk fails or picks nothing the room goes. ctx: el, get, subscribe, isStartVisible and
// what the card needs (see main.js).
export function initBumper(ok, ctx) {
	const root = document.documentElement;
	let chunk = null, loading = false, ready = false;
	const sync = () => {
		// Island Mode has no start page to show it on.
		const on = ok && bumperOn(ctx.get) && ctx.get("layout") !== "island";
		if (!on) { delete root.dataset.bumper; ctx.el.hidden = true; if (chunk) chunk.stop(); return; }
		root.dataset.bumper = "on";
		if (chunk) chunk.sync();
		else if (ready && !loading && ctx.isStartVisible()) {
			loading = true;
			import(__RVM.bumperJs).then((m) => { chunk = m.start(ctx); sync(); }).catch(() => { delete root.dataset.bumper; });
		}
	};
	ctx.subscribe(sync);
	new MutationObserver(sync).observe(ctx.startEl, { attributes: true, attributeFilter: ["hidden"] });
	const onLoad = () => (window.requestIdleCallback || setTimeout)(() => { ready = true; sync(); }, { timeout: 600 });
	if (document.readyState === "complete") onLoad(); else addEventListener("load", onLoad, { once: true });
	sync();
}
